var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',{staticClass:"display-1 pt-3"},[_vm._v("Responses by Course")]),_c('v-breadcrumbs',{staticClass:"pa-0 ma-0 mb-2 mt-2",attrs:{"items":_vm.items}}),_c('a-l-courses',{staticClass:"mt-2"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }